<template>
    <v-row class="mx-12">
        <v-col class="" cols="12">
            <v-card class="green lighten-4 pa-6 mx-auto elevation-12">
                <v-card-title class="display-2 text--primary justify-center font-weight-black"><p class="teal--text">표준요금표</p></v-card-title>
                <v-card class="pa-0 elevation-6">
                    <v-tabs
                        v-model="tab"
                        background-color="teal"
                        dark
                        grow
                      >
                        <v-tab
                          v-for="item in tabItems"
                        >
                          {{ item }}
                        </v-tab>
                      </v-tabs>

                      <v-tabs-items v-model="tab">
                          <v-tab-item>
                              <v-data-table
                                :headers="headers"
                                :items="compactCarPriceList"
                                :items-per-page="6"
                                hide-default-footer
                                class="elevation-3"
                              ></v-data-table>
                          </v-tab-item>
                        <v-tab-item>
                            <v-data-table
                              :headers="headers"
                              :items="lowCarPriceList"
                              :items-per-page="6"
                              hide-default-footer
                              class="elevation-3"
                            ></v-data-table>
                        </v-tab-item>
                        <v-tab-item>
                            <v-data-table
                              :headers="headers"
                              :items="mediumCarPriceList"
                              :items-per-page="6"
                              hide-default-footer
                              class="elevation-3"
                            ></v-data-table>
                        </v-tab-item>
                        <v-tab-item>
                            <v-data-table
                              :headers="headers"
                              :items="semiLargePriceList"
                              :items-per-page="6"
                              hide-default-footer
                              class="elevation-3"
                            ></v-data-table>
                        </v-tab-item>
                        <v-tab-item>
                            <v-data-table
                              :headers="headers"
                              :items="highCarPriceList"
                              :items-per-page="12"
                              hide-default-footer
                              class="elevation-3"
                            ></v-data-table>
                        </v-tab-item>
                        <v-tab-item>
                            <v-data-table
                              :headers="headers"
                              :items="suvPriceList"
                              :items-per-page="12"
                              hide-default-footer
                              class="elevation-3"
                            ></v-data-table>
                        </v-tab-item>
                        <v-tab-item>
                            <v-data-table
                              :headers="headers"
                              :items="rvPriceList"
                              :items-per-page="12"
                              hide-default-footer
                              class="elevation-3"
                            ></v-data-table>
                        </v-tab-item>
                        <v-tab-item>
                              <v-data-table
                                :headers="headers"
                                :items="importedPriceList"
                                :items-per-page="12"
                                hide-default-footer
                                class="elevation-3"
                              ></v-data-table>
                        </v-tab-item>
                      </v-tabs-items>
                  </v-card>
            </v-card>
        </v-col>
    </v-row>
</template>

<script>
export default {
  name: 'ShorttermPriceTable',
  data: () => ({
      tab: null,
      tabItems: [
        '경차', '소형', '중형', '준대형', '대형', 'SUV', '승합/RV', '수입'
      ],
      headers: [
          { text: '대여차종', value: 'carModel' },
          { text: '6시간', value: 'hours_6' },
          { text: '10시간', value: 'hours_10' },
          { text: '12시간', value: 'hours_12' },
          { text: '1~2일', value: 'days_1to2' },
          { text: '3~4일', value: 'days_3to4' },
          { text: '5~6일', value: 'days_5to6' },
          { text: '7일이상', value: 'days_7' }
      ],

      compactCarPriceList: [
          {
              carModel: '모닝 / 스파크',
              hours_6: '53,000',
              hours_10: '68,500',
              hours_12: '76,000',
              days_1to2: '95,000/일',
              days_3to4: '86,000/일',
              days_5to6: '81,000/일',
              days_7: '76,000/일'
          },
          {
              carModel: '레이',
              hours_6: '56,000',
              hours_10: '72,500',
              hours_12: '80,000',
              days_1to2: '100,000/일',
              days_3to4: '90,000/일',
              days_5to6: '85,000/일',
              days_7: '80,000/일'
          },
      ],
      lowCarPriceList: [
          {
              carModel: '아반떼 / K3 / SM3 / 벨로스터 / 클리오',
              hours_6: '62,000',
              hours_10: '79,000',
              hours_12: '88,000',
              days_1to2: '110,000/일',
              days_3to4: '99,000/일',
              days_5to6: '94,000/일',
              days_7: '88,000/일'
          },
          {
              carModel: 'I30 / 아이오닉 (H)',
              hours_6: '67,000',
              hours_10: '86,000',
              hours_12: '96,000',
              days_1to2: '120,000/일',
              days_3to4: '108,000/일',
              days_5to6: '102,000/일',
              days_7: '96,000/일'
          }
      ],
      mediumCarPriceList: [
          {
              carModel: '쏘나타 / K5 / SM6 / 말리부',
              hours_6: '95,000',
              hours_10: '122,000',
              hours_12: '136,000',
              days_1to2: '170,000/일',
              days_3to4: '153,000/일',
              days_5to6: '145,000/일',
              days_7: '136,000/일'
          },
          {
              carModel: '쏘나타 (L), K5 (L), SM6 (L)',
              hours_6: '98,000',
              hours_10: '126,500',
              hours_12: '140,000',
              days_1to2: '175,000/일',
              days_3to4: '158,000/일',
              days_5to6: '149,000/일',
              days_7: '140,000/일'
          },
          {
              carModel: 'G70 2.0T (G), 스팅어 2.0T (G)',
              hours_6: '167,000',
              hours_10: '215,000',
              hours_12: '239,000',
              days_1to2: '299,000/일',
              days_3to4: '269,000/일',
              days_5to6: '254,000/일',
              days_7: '239,000/일'
          }
      ],
      semiLargePriceList: [
          {
              carModel: '그랜저 IG 2.4 (G) / 2.2 (D) / K7 2.4 (G) / 2.2 (D)',
              hours_6: '160,000',
              hours_10: '205,000',
              hours_12: '228,000',
              days_1to2: '285,000/일',
              days_3to4: '256,000/일',
              days_5to6: '243,000/일',
              days_7: '228,000/일'
          },
          {
              carModel: '그랜져 IG 3.0, K7 3.0 / G70 2.2 (D), 스팅어 2.2 (D) / 임팔라 2.5',
              hours_6: '174,000',
              hours_10: '223,000',
              hours_12: '248,000',
              days_1to2: '310,000/일',
              days_3to4: '279,000/일',
              days_5to6: '264,000/일',
              days_7: '248,000/일'
          }
      ],
      highCarPriceList: [
          {
              carModel: 'G80 2.2 (D), G80 3.3, K9 3.3, 임팔라 3.6',
              hours_6: '223,000',
              hours_10: '287,000',
              hours_12: '319,600',
              days_1to2: '399,000/일',
              days_3to4: '359,000/일',
              days_5to6: '339,000/일',
              days_7: '319,000/일'
          },
          {
              carModel: 'G80 3.3 T / 3.8, K9 3.8',
              hours_6: '251,000',
              hours_10: '322,000',
              hours_12: '358,600',
              days_1to2: '447,000/일',
              days_3to4: '402,000/일',
              days_5to6: '380,000/일',
              days_7: '358,000/일'
          },
          {
              carModel: 'G90 3.3 T / 3.8',
              hours_6: '263,400',
              hours_10: '338,300',
              hours_12: '376,200',
              days_1to2: '470,000/일',
              days_3to4: '423,000/일',
              days_5to6: '400,000/일',
              days_7: '376,000/일'
          },
          {
              carModel: 'G90 5.0',
              hours_6: '325,000',
              hours_10: '418,000',
              hours_12: '464,000',
              days_1to2: '580,000/일',
              days_3to4: '522,000/일',
              days_5to6: '493,000/일',
              days_7: '464,000/일'
          }
      ],
      suvPriceList: [
          {
              carModel: '스토닉, 코나, 셀토스, 니로, QM3, 티볼리, 코란도, 트랙스',
              hours_6: '101,000',
              hours_10: '130,000',
              hours_12: '144,000',
              days_1to2: '180,000/일',
              days_3to4: '162,000/일',
              days_5to6: '153,000/일',
              days_7: '144,000/일'
          },
          {
              carModel: '투싼, 스포티지, 이쿼녹스',
              hours_6: '112,000',
              hours_10: '144,000',
              hours_12: '160,000',
              days_1to2: '200,000/일',
              days_3to4: '180,000/일',
              days_5to6: '170,000/일',
              days_7: '160,000/일'
          },
          {
              carModel: '싼타페, 쏘렌토, QM6',
              hours_6: '137,000',
              hours_10: '176,000',
              hours_12: '196,000',
              days_1to2: '245,000/일',
              days_3to4: '221,000/일',
              days_5to6: '208,000/일',
              days_7: '196,000/일'
          },
          {
              carModel: '팰리세이드, G4 렉스턴',
              hours_6: '167,000',
              hours_10: '215,000',
              hours_12: '239,000',
              days_1to2: '299,000/일',
              days_3to4: '269,000/일',
              days_5to6: '254,000/일',
              days_7: '239,000/일'
          },
          {
              carModel: '모하비',
              hours_6: '196,000',
              hours_10: '252,000',
              hours_12: '280,000',
              days_1to2: '350,000/일',
              days_3to4: '315,000/일',
              days_5to6: '298,000/일',
              days_7: '280,000/일'
          },
          {
              carModel: 'GV80',
              hours_6: '252,000',
              hours_10: '325,000',
              hours_12: '360,000',
              days_1to2: '450,000/일',
              days_3to4: '405,000/일',
              days_5to6: '382,000/일',
              days_7: '360,000/일'
          }
      ],
      rvPriceList: [
          {
              carModel: '스타렉스 11인승 / 12인승',
              hours_6: '123,000',
              hours_10: '158,000',
              hours_12: '176,000',
              days_1to2: '220,000/일',
              days_3to4: '198,000/일',
              days_5to6: '187,000/일',
              days_7: '176,000/일'
          },
          {
              carModel: '스타렉스 9인승',
              hours_6: '134,000',
              hours_10: '173,000',
              hours_12: '192,000',
              days_1to2: '240,000/일',
              days_3to4: '216,000/일',
              days_5to6: '204,000/일',
              days_7: '192,000/일'
          },
          {
              carModel: '카니발 9인승',
              hours_6: '151,000',
              hours_10: '194,000',
              hours_12: '216,000',
              days_1to2: '270,000/일',
              days_3to4: '243,000/일',
              days_5to6: '230,000/일',
              days_7: '216,000/일'
          },
          {
              carModel: '카니발 7인승 리무진',
              hours_6: '162,000',
              hours_10: '209,000',
              hours_12: '232,000',
              days_1to2: '290,000/일',
              days_3to4: '261,000/일',
              days_5to6: '247,000/일',
              days_7: '232,000/일'
          },
          {
              carModel: '카니발 11인승',
              hours_6: '167,000',
              hours_10: '215,000',
              hours_12: '239,000',
              days_1to2: '299,000/일',
              days_3to4: '269,000/일',
              days_5to6: '254,000/일',
              days_7: '239,000/일'
          },
          {
              carModel: '카니발 7인승 / 9인승 하이리무진',
              hours_6: '207,000',
              hours_10: '266,000',
              hours_12: '296,000',
              days_1to2: '370,000/일',
              days_3to4: '333,000/일',
              days_5to6: '315,000/일',
              days_7: '296,000/일'
          },
          {
              carModel: '르노 마스터',
              hours_6: '252,000',
              hours_10: '324,000',
              hours_12: '360,000',
              days_1to2: '450,000/일',
              days_3to4: '405,000/일',
              days_5to6: '382,600/일',
              days_7: '360,000/일'
          },
          {
              carModel: '쏠라티',
              hours_6: '308,000',
              hours_10: '396,000',
              hours_12: '440,000',
              days_1to2: '550,000/일',
              days_3to4: '495,000/일',
              days_5to6: '479,600/일',
              days_7: '440,000/일'
          }
      ],
      importedPriceList: [
          {
              carModel: 'AUDI A3 / JEEP CHEROKEE RENEGADE / JEEP WRANGLER / MINI COOPER / MUSTANG COUPE / PEUGEOT 3008 / VOLKSWAGEN BEETLE / VOLKSWAGEN JETTA',
              hours_6: '196,000',
              hours_10: '252,000',
              hours_12: '280,000',
              days_1to2: '350,000/일',
              days_3to4: '315,000/일',
              days_5to6: '298,000/일',
              days_7: '280,000/일'
          },
          {
              carModel: 'BMW 118D / FORD TAURUS / HONDA CR-V 4WD / LEXUS CT200H / VOLKSWAGEN GOLF / VOLKSWAGEN PASSAT / INFINITI Q50 / TOYOTA CAMRY',
              hours_6: '213,000',
              hours_10: '274,000',
              hours_12: '304,000',
              days_1to2: '380,000/일',
              days_3to4: '342,000/일',
              days_5to6: '323,000/일',
              days_7: '304,000/일'
          },
          {
              carModel: 'TOYOTA CAMRY HYBRID',
              hours_6: '224,000',
              hours_10: '288,000',
              hours_12: '320,000',
              days_1to2: '400,000/일',
              days_3to4: '360,000/일',
              days_5to6: '340,000/일',
              days_7: '320,000/일'
          },
          {
              carModel: 'AUDI A4 / AUDI A5 / BMW 320D / FORD EXPLORER 3.5 / LEXUS NX300H / LINCOLN MKC / TOYOTA SIENNA 3.5 4WD / VOLKSWAGEN CC / VOLVO S60',
              hours_6: '252,000',
              hours_10: '324,000',
              hours_12: '360,000',
              days_1to2: '450,000/일',
              days_3to4: '405,000/일',
              days_5to6: '383,000/일',
              days_7: '360,000/일'
          },
          {
              carModel: 'AUDI A6 / BMW 520D/528i / CADILLAC CTS / EXPLORER CHEVY VAN / LAND ROVER DISCOVERY / LEXUS ES300H / LEXUS NX300H EXECUTIVE / MUSTANG 5.0 COUPE / RANGE ROVER EVOQUE / VOLKSWAGEN TOUAREG / JEEP GRAND CHEROKEE / INFINITI QX60',
              hours_6: '280,000',
              hours_10: '360,000',
              hours_12: '400,000',
              days_1to2: '500,000/일',
              days_3to4: '450,000/일',
              days_5to6: '425,000/일',
              days_7: '400,000/일'
          },
          {
              carModel: 'CHEVY STARLIMO VAN / AUDI A6 TFSI QU SPORT / AUDI Q7 / BMW X5/X6 / VOLKSWAGEN PHAETON',
              hours_6: '308,000',
              hours_10: '396,000',
              hours_12: '440,000',
              days_1to2: '550,000/일',
              days_3to4: '495,000/일',
              days_5to6: '468,000/일',
              days_7: '440,000/일'
          },
          {
              carModel: 'AUDI A7 / AUDI Q5 / BMW 528i xDrive / BMW GT',
              hours_6: '325,000',
              hours_10: '418,000',
              hours_12: '464,000',
              days_1to2: '580,000/일',
              days_3to4: '522,000/일',
              days_5to6: '493,000/일',
              days_7: '464,000/일'
          },
          {
              carModel: 'AUDI SQ5',
              hours_6: '336,000',
              hours_10: '432,000',
              hours_12: '480,000',
              days_1to2: '600,000/일',
              days_3to4: '540,000/일',
              days_5to6: '510,000/일',
              days_7: '480,000/일'
          },
          {
              carModel: 'CHEVY STARCRAFT VAN / BMW 730D / BMW M4 / CADILLAC CT6 / EXPLORER LONG VAN / RANGE ROVER SPORTS / PORSCHE CAYENNE',
              hours_6: '364,000',
              hours_10: '468,000',
              hours_12: '520,000',
              days_1to2: '650,000/일',
              days_3to4: '585,000/일',
              days_5to6: '553,000/일',
              days_7: '520,000/일'
          },
          {
              carModel: 'AUDI A8 / AUDI RS5 / BMW 730Ld/740Li / BMW M5 / PORSCHE PANAMERA',
              hours_6: '392,000',
              hours_10: '504,000',
              hours_12: '560,000',
              days_1to2: '700,000/일',
              days_3to4: '630,000/일',
              days_5to6: '595,000/일',
              days_7: '560,000/일'
          },
          {
              carModel: 'NEW BMW 750Li',
              hours_6: '448,000',
              hours_10: '476,000',
              hours_12: '640,000',
              days_1to2: '800,000/일',
              days_3to4: '720,000/일',
              days_5to6: '680,000/일',
              days_7: '640,000/일'
          }
      ]
  }),
};
</script>

<style scoped>
</style>
